module.exports = __webpack_public_path__ + "static/media/check.4cdf42d4.svg";